import Icon from '../../../components/AppIcon';
import { ServiceCategory } from '../types';

interface ServiceCategoriesProps {
  categories: ServiceCategory[];
  activeCategory: string;
  onCategoryChange: (id: string) => void;
}

const ServiceCategories = ({ categories, activeCategory, onCategoryChange }: ServiceCategoriesProps) => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
      {categories.map((category) => {
        const isActive = activeCategory === category.id;
        return (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`
              flex items-center space-x-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 border
              ${isActive 
                ? 'bg-primary text-white border-primary shadow-lg shadow-primary/25 scale-105' 
                : 'bg-background text-muted-foreground border-border hover:border-primary/50 hover:text-foreground'
              }
            `}
          >
            <Icon 
              name={category.icon} 
              size={16} 
              className={isActive ? 'text-white' : 'text-muted-foreground'} 
            />
            <span>{category.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ServiceCategories;